import React, { useState, useEffect, useMemo } from 'react';
import { ShieldCheck, Truck, CirclePlus } from 'lucide-react';
import './Hero.css';

const Hero = ({ onInquireClick }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const slides = useMemo(() => [
    {
      title: 'Nationwide Transportation and Freight Solutions',
      subtitle: 'Reliable. Flexible. Scalable.',
      image: `${process.env.PUBLIC_URL}/assets/images/demo.png`,
    }
  ], []);

  // Automatic slide transition
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <section className="hero-container">
      {/* Background Images Layer */}
      {slides.map((slide, idx) => (
        <div
          key={idx}
          className={`hero-background ${idx === currentIndex ? 'is-active' : ''}`}
          style={{ backgroundImage: `url(${slide.image})` }}
          aria-hidden="true"
        />
      ))}

      {/* Dark Gradient Overlay */}
      <div className="hero-overlay" aria-hidden="true" />

      {/* Main Content Area */}
      <div className="hero-content">
        <div className="hero-copy">
          <div className="hero-carousel-slide">
            <h1 className="hero-title">{slides[currentIndex].title}</h1>
            <p className="hero-subtitle">{slides[currentIndex].subtitle}</p>
          </div>

          <div className="hero-cta-row">
            <button className="hero-cta-button" onClick={onInquireClick}>
              Request a Quote
            </button>
            <a className="hero-call-btn" href="tel:+14704068861">
              Call Us: 470-406-8861
            </a>
          </div>

          <p className="hero-contact-note">
            Your trusted partner for 24/7 nationwide dry-van transportation and logistics solutions.
          </p>
        </div>
      </div>

      {/* Trust Icons - Hidden on Mobile via CSS */}
      <div className="hero-icons-row">
        <div className="icon-item">
          <ShieldCheck className="icon-lucide" size={40} strokeWidth={1.5} />
          <span className="icon-text">Nationwide Coverage</span>
        </div>
        <div className="icon-item">
          <Truck className="icon-lucide" size={40} strokeWidth={1.5} />
          <span className="icon-text">Dedicated & Contract Freight</span>
        </div>
        <div className="icon-item">
          <CirclePlus className="icon-lucide" size={40} strokeWidth={1.5} />
          <span className="icon-text">24/7 Tracking & Support</span>
        </div>
      </div>
    </section>
  );
};

export default Hero;